import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Container } from '@mui/material';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      // User is authenticated, redirect to their dashboard
      const userData = JSON.parse(user);
      const role = userData.role;
      
      if (role === 'admin') {
        navigate('/admin/dashboard');
      } else if (role === 'client') {
        navigate('/client/dashboard');
      } else if (role === 'respondent') {
        navigate('/respondent/dashboard');
      } else {
        // Unknown role, redirect to login
        navigate('/login');
      }
    } else {
      // No authentication, redirect to login
      navigate('/login');
    }
  }, [navigate]);

  return (
    <Container>
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    </Container>
  );
}
